export const ADD_TAB_ID = 'add-tab';
